module.exports = __webpack_public_path__ + "img/pos-equals-xsn.e0519f9e.jpg";